// client/src/coms/views/chatview_parts/chatUploadUtils.js

function safeArray(v) {
  return Array.isArray(v) ? v : [];
}

function toInt(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? Math.floor(n) : fallback;
}

export function toAbsoluteUrl(url) {
  const raw = String(url || '').trim();
  if (!raw) return '';

  try {
    return new URL(raw).toString();
  } catch {}

  try {
    if (typeof window !== 'undefined' && window.location && window.location.origin) {
      return new URL(raw, window.location.origin).toString();
    }
  } catch {}

  return raw;
}

export function normalizePendingUpload(item) {
  const upload = item && typeof item === 'object' ? item : {};
  const uploadId = toInt(upload.id, 0);
  const mediaKind = String(upload.media_kind || '').trim() || 'file';
  const publicUrl = toAbsoluteUrl(upload.public_url || '');
  const thumbUrl = toAbsoluteUrl(upload.thumb_url || '');
  const originalName = String(upload.original_name || upload.stored_name || `upload-${uploadId || 'x'}`).trim();

  return {
    id: uploadId,
    media_kind: mediaKind,
    public_url: publicUrl,
    thumb_url: thumbUrl,
    original_name: originalName,
  };
}

export function normalizeUploadList(items) {
  return safeArray(items)
    .map((item) => normalizePendingUpload(item))
    .filter((item) => item.id > 0 || item.public_url);
}

export function buildAttachmentBodyText(pendingUploads) {
  const urls = normalizeUploadList(pendingUploads)
    .map((item) => String(item.public_url || '').trim())
    .filter(Boolean);

  if (!urls.length) return '';
  return urls.join('\n');
}

export function composeOutgoingMessageBodyWithUploads(draft, pendingQuote, pendingUploads, buildQuoteBlockFromPending) {
  const quotePrefix = pendingQuote && typeof buildQuoteBlockFromPending === 'function'
    ? buildQuoteBlockFromPending(pendingQuote)
    : '';
  const bodyText = String(draft || '').trim();
  const attachmentText = buildAttachmentBodyText(pendingUploads);

  if (bodyText && attachmentText) {
    return `${quotePrefix}${bodyText}\n\n${attachmentText}`.trim();
  }

  if (bodyText) {
    return `${quotePrefix}${bodyText}`.trim();
  }

  if (attachmentText) {
    return `${quotePrefix}${attachmentText}`.trim();
  }

  return '';
}

export async function uploadFilesToComms(files) {
  const list = Array.from(files || []).filter(Boolean);
  const out = [];

  for (const file of list) {
    const form = new FormData();
    form.append('file', file);

    const res = await fetch('/api/coms/uploads', {
      method: 'POST',
      credentials: 'include',
      body: form,
    });

    const payload = await res.json().catch(() => null);

    if (!res.ok || !payload || !payload.ok || !payload.upload) {
      throw new Error(
        String(
          (payload && (payload.error || payload.detail)) ||
          `Upload failed (${res.status})`
        )
      );
    }

    out.push(normalizePendingUpload(payload.upload));
  }

  return out;
}

export function mergeMessageContentAndAttachments(content, attachments) {
  const normalizedAttachments = normalizeUploadList(attachments);
  const attachmentUrls = normalizedAttachments
    .map((item) => String(item.public_url || '').trim())
    .filter(Boolean);
  const text = String(content || '');

  return attachmentUrls.length
    ? [text, attachmentUrls.join('\n')].filter(Boolean).join(text ? '\n\n' : '\n')
    : text;
}